<ndt-edit-allowed-ip-view
   [callState]="callState | async"
   [form]="form"
   [selectedAccountId]="selectedAccountId$ | async"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onSave()"
>
</ndt-edit-allowed-ip-view>
